const path = "/data/output/";

export const BASE_DEV_URL = "https://testing.ncsa.or.th";

const devUrl = BASE_DEV_URL + path;
const prodUrl = path;

export const API_URL =
  window.location.hostname === "localhost" ? devUrl : prodUrl;
